const fileIconModules = import.meta.glob('../assets/icons/*-file.svg', {
    eager: true,
    import: 'default',
});

function normalizeExt(ext) {
    return String(ext || '')
        .trim()
        .replace(/^\./, '')
        .toLowerCase();
}

function getExtFromName(name) {
    const n = String(name || '').trim();
    const m = n.match(/\.([a-z0-9]+)$/i);
    return m ? normalizeExt(m[1]) : '';
}

export function getFileExtension({ name, url } = {}) {
    return getExtFromName(name) || getExtFromName(url);
}

function getIconKeyByExt(ext) {
    const e = normalizeExt(ext);
    if (!e) return 'txt-file';
    if (e === 'pdf') return 'pdf-file';
    if (e === 'doc' || e === 'docx') return `${e}-file`;
    if (e === 'ppt' || e === 'pptx') return `${e}-file`;
    if (e === 'xls' || e === 'xlsx') return `${e}-file`;
    if (e === 'txt') return 'txt-file';
    if (e === 'zip' || e === 'rar' || e === '7z') return 'zip-file';
    if (e === 'jpg' || e === 'jpeg') return `${e}-file`;
    if (e === 'png') return 'png-file';
    if (e === 'mp4' || e === 'webm' || e === 'mov' || e === 'mkv' || e === 'avi' || e === 'm4v') return 'mp4-file';
    return 'txt-file';
}

function buildIconMap() {
    const map = new Map();
    for (const [path, url] of Object.entries(fileIconModules)) {
        const base = String(path).split('/').pop() || '';
        const key = base.replace(/\.svg$/i, '');
        map.set(key, url);
    }
    return map;
}

const ICON_MAP = buildIconMap();

export function getFileIconSrc({ name, url, mimeType } = {}) {
    const mt = String(mimeType || '').toLowerCase();
    if (mt.startsWith('video/')) return ICON_MAP.get('mp4-file') || ICON_MAP.get('txt-file') || null;
    const ext = getExtFromName(name) || getExtFromName(url);
    const key = getIconKeyByExt(ext);
    return ICON_MAP.get(key) || ICON_MAP.get('txt-file') || null;
}

export function getFileTypeLabel({ name, url } = {}) {
    const ext = getExtFromName(name) || getExtFromName(url);
    if (!ext) return 'Document';
    if (ext === 'pdf') return 'PDF document';
    if (ext === 'doc' || ext === 'docx') return 'Word document';
    if (ext === 'ppt' || ext === 'pptx') return 'PowerPoint';
    if (ext === 'xls' || ext === 'xlsx') return 'Excel sheet';
    if (ext === 'zip') return 'Archive';
    if (ext === 'txt') return 'Text file';
    if (ext === 'mp4' || ext === 'webm' || ext === 'mov' || ext === 'mkv' || ext === 'avi' || ext === 'm4v') return 'Video';
    return `${ext.toUpperCase()} file`;
}

